// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-2e75889c],h3[data-v-2e75889c]{color:var(--color-text)}.progress[data-v-2e75889c]{position:fixed}.toolbar[data-v-2e75889c]{display:flex;align-items:center;gap:.5rem}.bar[data-v-2e75889c]{height:100%;background-color:var(--color-text);color:var(--color-text)}", ""]);
// Exports
module.exports = exports;
